import styled from '@emotion/styled';
import { Button, Drawer, Input, Modal, Space, Table, Tag } from 'antd';
import { useEffect, useState } from 'react';
import { FaMoneyBill, FaPen, FaPlus, FaTrash } from 'react-icons/fa';
import { MdClose } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { ConnectedUserEntity } from '../../../../entities/ConnectedUserEntity';
import {
  AbonnementType,
  AssetManagerType,
  PackType,
} from '../../../../redux/userStore/reducer';
import { PRIMARY, YELLOW } from '../../../../shared/colors';
import {
  deleteAssetManager,
  getAssetManagers,
  getPack,
  listAbonnement,
} from '../../../dashboard/network';
import { Layout } from '../../../shared/Layout';
import { AbonnementForm } from '../components/AbonnementForm';
import { AssetForm } from '../components/AssetForm';
import { AssetUpdateForm } from '../components/AssetUpdateForm';

const Container = styled.div`
  height: calc(100vh - 30px);
  display: flex;
  background-color: #1c2025;
  color: white;

  .bread-crum span {
    color: white;
  }

  td.ant-table-column-sort {
    background-color: transparent !important;
  }

  th {
    background-color: ${PRIMARY} !important;
    color: white !important;
    font-weight: bold;
  }

  .odd-row {
    background-color: #757575;
    color: white;
  }

  .even-row {
    background-color: #acacac;
    color: white;
  }

  .odd-row,
  .even-row {
    &:hover > td {
      background-color: ${YELLOW} !important;
      cursor: pointer;
      color: black; /* plus lisible */
    }
  }

  .content {
    padding: 50px;
    width: 100%;
    background-color: #1c2025;
    color: white;
  }
`;

export const MoranjeAdmin = () => {
  const COLUMNS = [
    {
      title: 'NOM CLIENT',
      render: (cell: any, row: AssetManagerType) => row.nom,
      sorter: (a: AssetManagerType, b: AssetManagerType) =>
        a.nom.localeCompare(b.nom),
    },
    {
      title: 'EMAIL',
      render: (cell: any, row: AssetManagerType) => row.email,
      sorter: (a: AssetManagerType, b: AssetManagerType) =>
        a.email.localeCompare(b.email),
    },
    {
      title: 'ADRESSE',
      render: (cell: any, row: AssetManagerType) => row.adresse,
      sorter: (a: AssetManagerType, b: AssetManagerType) =>
        a.adresse.localeCompare(b.adresse),
    },
    {
      title: 'CONTACT',
      render: (cell: any, row: AssetManagerType) => row.contact,
      sorter: (a: AssetManagerType, b: AssetManagerType) =>
        a.contact.localeCompare(b.contact),
    },
    {
      title: 'ABONNEMENT',
      render: (cell: any, row: AssetManagerType) => {
        return (
          <Space>
            {Date.parse(row.fin_abonnement) >= Date.now() ? (
              <Tag color='green'>En cours</Tag>
            ) : (
              <Tag color='red'>Fini</Tag>
            )}
          </Space>
        );
      },
      flex: 2,
    },
    {
      title: 'FIN ABONNEMENT',
      render: (cell: any, row: AssetManagerType) => row.fin_abonnement,
    },
    {
      title: 'Action',
      render: (cell: any, row: AssetManagerType) => (
        <Space>
          <Button
            icon={<FaPen style={{ color: 'orange', marginBottom: -2 }} />}
            style={{
              backgroundColor: 'transparent',
              borderRadius: 20,
              zoom: 0.8,
            }}
            onClick={() => {
              setSelectedAsset(row);
              setShowDrawer1(true);
            }}
          />
          <Button
            icon={<FaMoneyBill style={{ color: 'orange', marginBottom: -2 }} />}
            style={{
              backgroundColor: 'transparent',
              borderRadius: 20,
              zoom: 0.8,
            }}
            onClick={() => {
              setSelectedAsset(row);
              setShowDrawer2(true);
            }}
          />
        </Space>
      ),
    },
  ];

  const COLUMNS_AB = [
    {
      title: 'NOM PACK',
      render: (cell: any, row: AbonnementType) => row.pack.nom,
      sorter: (a: AbonnementType, b: AbonnementType) =>
        a.pack.nom.localeCompare(b.pack.nom),
    },
    {
      title: 'Montant',
      render: (cell: any, row: AbonnementType) => row.pack.amount,
    },
    {
      title: 'Date souscription',
      render: (cell: any, row: AbonnementType) => row.created_at,
    },
    {
      title: 'Date fin',
      render: (cell: any, row: AbonnementType) => row.fin_abonnement,
    },
  ];
  const connectedUser: ConnectedUserEntity = useSelector(
    (state: any) => state.userReducer,
  ).user;
  const [isLoading, setIsLoading] = useState(true);
  const [showDrawer, setShowDrawer] = useState(false);
  const [showDrawer1, setShowDrawer1] = useState(false);
  const [showDrawer2, setShowDrawer2] = useState(false);
  const [assetManager, setAssetManager] = useState<AssetManagerType[]>([]);
  const [filterClient, setFilterClient] = useState<AssetManagerType[]>([]);
  const [pack, setPack] = useState<PackType[]>([]);
  const [selectedAsset, setSelectedAsset] = useState<AssetManagerType>({
    id: '',
    nom: '',
    adresse: '',
    email: '',
    contact: '',
    created_at: '',
    updated_at: '',
    count: '',
    achat: 0,
    vente: 0,
    fin_abonnement: '',
    abonnement: [],
  });

  const [showDeleteModal, setShowDeleteModal] = useState(false);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = () => {
    setIsLoading(true);
    getAssetManagers().then(({ data: filterClient }) => {
      filterClient.map((item: AssetManagerType) => {
        item.abonnement = [];
        listAbonnement(connectedUser.id, item.id).then(({ data }) => {
          item.abonnement = data;
        });
        return item;
      });
      setAssetManager(filterClient);
      setFilterClient(filterClient);
      console.log(filterClient);
      setIsLoading(false);
    });
    getPack().then(({ data }) => {
      setPack(data);
    });
  };
  const deleteAsset = () => {
    setIsLoading(true);
    if (selectedAsset) {
      deleteAssetManager(connectedUser.id, selectedAsset.id).then(() => {
        setIsLoading(false);
        setShowDeleteModal(false);
        fetchData();
      });
    }
  };
  return (
    <Layout>
      <Container>
        {/** Obtain 'current' values in Sidebar component */}
        <div className='content'>
          <div style={{ marginTop: 1 }}>
            <h2 style={{ color: 'white' }}>Liste des clients MoranjEtrade</h2>

            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: 5,
              }}
            >
              <Input
                placeholder='Search...'
                style={{ width: 250 }}
                onChange={(e) => {
                  setFilterClient(
                    assetManager.filter(
                      (p) =>
                        p.nom
                          .toLowerCase()
                          .includes(e.target.value.toLowerCase()) ||
                        p.adresse
                          .toLowerCase()
                          .includes(e.target.value.toLowerCase()) ||
                        p.email
                          .toLowerCase()
                          .includes(e.target.value.toLowerCase()),
                    ),
                  );
                }}
              />

              <Button
                icon={<FaPlus style={{ marginBottom: -2, marginRight: 5 }} />}
                className='butt'
                style={{ borderRadius: 5 }}
                onClick={() => setShowDrawer(true)}
              >
                Nouveau client
              </Button>
            </div>

            <Table
              columns={COLUMNS}
              dataSource={filterClient}
              rowClassName={(row, index) =>
                index % 2 === 0 ? 'even-row' : 'odd-row'
              }
              size='small'
              loading={isLoading}
              style={{ zoom: 0.9 }}
              pagination={false}
              onRow={(row, rowIndex) => {
                return {
                  onClick: (event) => {}, // click row
                  onDoubleClick: (event) => {}, // double click row
                  onContextMenu: (event) => {}, // right button click row
                  onMouseEnter: (event) => {}, // mouse enter row
                  onMouseLeave: (event) => {}, // mouse leave row
                };
              }}
            />
          </div>
        </div>
        <Drawer
          title='Ajouter un client MoranjEtrade'
          placement='right'
          width={400}
          onClose={() => setShowDrawer(false)}
          open={showDrawer}
          closeIcon={<MdClose size={20} />}
        >
          <AssetForm
            setShowDrawer={setShowDrawer}
            getNewAsset={(part) => {
              setAssetManager([...assetManager, part]);
              setFilterClient([...filterClient, part]);
            }}
          />
        </Drawer>
        <Drawer
          title="Abonnement d'un client MoranjEtrade"
          placement='right'
          width={400}
          onClose={() => setShowDrawer2(false)}
          open={showDrawer2}
          closeIcon={<MdClose size={20} />}
        >
          <h2>Abonnement pour {selectedAsset.nom}</h2>
          <h4>Liste des abonnements souscrits</h4>
          <Table
            columns={COLUMNS_AB}
            dataSource={selectedAsset.abonnement}
            rowClassName='style-row'
            size='small'
            style={{ zoom: 0.9 }}
            pagination={false}
            onRow={(row, rowIndex) => {
              return {
                onClick: (event) => {}, // click row
                onDoubleClick: (event) => {}, // double click row
                onContextMenu: (event) => {}, // right button click row
                onMouseEnter: (event) => {}, // mouse enter row
                onMouseLeave: (event) => {}, // mouse leave row
              };
            }}
          />
          <AbonnementForm
            setShowDrawer={setShowDrawer2}
            pack={pack}
            settheasset={selectedAsset}
            getNewAsset={(part) => {
              setAssetManager(part);
              setFilterClient(part);
            }}
          />
        </Drawer>
        <Drawer
          title='Modifier un client'
          placement='right'
          width={400}
          onClose={() => setShowDrawer1(false)}
          open={showDrawer1}
          closeIcon={<MdClose size={20} />}
        >
          <AssetUpdateForm
            setShowDrawer={setShowDrawer1}
            settheasset={selectedAsset}
            getNewAsset={(client) => {
              setAssetManager(client);
              setFilterClient(client);
            }}
          />
          <Button
            icon={<FaTrash style={{ marginBottom: -2, marginRight: 5 }} />}
            className='butt'
            loading={isLoading}
            style={{ borderRadius: 5, backgroundColor: PRIMARY }}
            onClick={() => {
              setShowDeleteModal(true);
              setShowDrawer1(false);
            }}
          >
            Supprimer
          </Button>
        </Drawer>
        <Modal
          open={showDeleteModal}
          title='Supprimer le client'
          onCancel={() => setShowDeleteModal(false)}
          footer={[
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Button
                danger
                onClick={() => setShowDeleteModal(false)}
                style={{ border: '2px solid red', borderRadius: 20 }}
              >
                Non
              </Button>
              <Button
                className='butt'
                loading={isLoading}
                style={{ borderRadius: 20 }}
                onClick={deleteAsset}
              >
                Oui
              </Button>
            </div>,
          ]}
        >
          <p>Voulez-vous supprimer ce client ?</p>
        </Modal>
        ;
      </Container>
    </Layout>
  );
};
